"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5449],{

/***/ 65449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ InfoPageLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./src/utils/graphql.ts
var graphql = __webpack_require__(75509);
// EXTERNAL MODULE: ./src/utils/getChangeForPeriod.ts
var getChangeForPeriod = __webpack_require__(19683);
// EXTERNAL MODULE: ./src/utils/getDeltaTimestamps.ts
var getDeltaTimestamps = __webpack_require__(79900);
// EXTERNAL MODULE: ./src/views/Info/hooks/useBlocksFromTimestamps.ts
var useBlocksFromTimestamps = __webpack_require__(79566);
// EXTERNAL MODULE: ./src/views/Info/utils/infoDataHelpers.ts
var infoDataHelpers = __webpack_require__(40393);
;// CONCATENATED MODULE: ./src/state/info/queries/protocol/overview.ts




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "query overview {\n      pancakeFactories(\n        ",
        "\n        first: 1) {\n        totalTransactions\n        totalVolumeUSD\n        totalLiquidityUSD\n      }\n    }"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







/**
 * Latest Liquidity, Volume and Transaction count
 */ var getOverviewData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(block) {
        var query, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    query = (0,dist.gql)(_templateObject(), block ? "block: { number: ".concat(block, "}") : "");
                    _ctx.next = 4;
                    return graphql/* infoClient.request */.dQ.request(query);
                case 4:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", {
                        data: data,
                        error: false
                    });
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Failed to fetch info overview", _ctx.t0);
                    return _ctx.abrupt("return", {
                        data: null,
                        error: true
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function getOverviewData(block) {
        return _ref.apply(this, arguments);
    };
}();
var formatPancakeFactoryResponse = function(rawPancakeFactory) {
    if (rawPancakeFactory) {
        return {
            totalTransactions: parseFloat(rawPancakeFactory.totalTransactions),
            totalVolumeUSD: parseFloat(rawPancakeFactory.totalVolumeUSD),
            totalLiquidityUSD: parseFloat(rawPancakeFactory.totalLiquidityUSD)
        };
    }
    return null;
};
var useFetchProtocolData = function() {
    var ref = (0,react.useState)({
        error: false
    }), fetchState = ref[0], setFetchState = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,getDeltaTimestamps/* getDeltaTimestamps */.z)(), 2), t24 = ref1[0], t48 = ref1[1];
    var ref2 = (0,useBlocksFromTimestamps/* useBlocksFromTimestamps */.Z)([
        t24,
        t48
    ]), blocks = ref2.blocks, blockError = ref2.error;
    var ref3 = (0,_sliced_to_array/* default */.Z)(blocks !== null && blocks !== void 0 ? blocks : [], 2), block24 = ref3[0], block48 = ref3[1];
    (0,react.useEffect)(function() {
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, error, data, ref7, error24, data24, ref8, error48, data48, anyError, overviewData, overviewData24, overviewData48, allDataAvailable, ref9, volumeUSD, volumeUSDChange, liquidityUSDChange, ref10, txCount, txCountChange, protocolData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            ;
                            _ctx.t0 = _sliced_to_array/* default */.Z;
                            _ctx.next = 5;
                            return Promise.all([
                                getOverviewData(),
                                getOverviewData((ref3 = block24 === null || block24 === void 0 ? void 0 : block24.number) !== null && ref3 !== void 0 ? ref3 : undefined),
                                getOverviewData((ref4 = block48 === null || block48 === void 0 ? void 0 : block48.number) !== null && ref4 !== void 0 ? ref4 : undefined), 
                            ]);
                        case 5:
                            _ctx.t1 = _ctx.sent;
                            ref5 = (0, _ctx.t0)(_ctx.t1, 3);
                            ref6 = ref5[0];
                            error = ref6.error;
                            data = ref6.data;
                            ref7 = ref5[1];
                            error24 = ref7.error;
                            data24 = ref7.data;
                            ref8 = ref5[2];
                            error48 = ref8.error;
                            data48 = ref8.data;
                            anyError = error || error24 || error48;
                            overviewData = formatPancakeFactoryResponse(data === null || data === void 0 ? void 0 : (ref = data.pancakeFactories) === null || ref === void 0 ? void 0 : ref[0]);
                            overviewData24 = formatPancakeFactoryResponse(data24 === null || data24 === void 0 ? void 0 : (ref1 = data24.pancakeFactories) === null || ref1 === void 0 ? void 0 : ref1[0]);
                            overviewData48 = formatPancakeFactoryResponse(data48 === null || data48 === void 0 ? void 0 : (ref2 = data48.pancakeFactories) === null || ref2 === void 0 ? void 0 : ref2[0]);
                            allDataAvailable = overviewData && overviewData24 && overviewData48;
                            if (anyError || !allDataAvailable) {
                                setFetchState({
                                    error: true
                                });
                            } else {
                                ref9 = (0,_sliced_to_array/* default */.Z)((0,getChangeForPeriod/* getChangeForPeriod */.T)(overviewData.totalVolumeUSD, overviewData24.totalVolumeUSD, overviewData48.totalVolumeUSD), 2), volumeUSD = ref9[0], volumeUSDChange = ref9[1];
                                liquidityUSDChange = (0,infoDataHelpers/* getPercentChange */.Y)(overviewData.totalLiquidityUSD, overviewData24.totalLiquidityUSD);
                                ref10 = (0,_sliced_to_array/* default */.Z)((0,getChangeForPeriod/* getChangeForPeriod */.T)(overviewData.totalTransactions, overviewData24.totalTransactions, overviewData48.totalTransactions), 2), txCount = ref10[0], txCountChange = ref10[1];
                                protocolData = {
                                    volumeUSD: volumeUSD,
                                    volumeUSDChange: typeof volumeUSDChange === "number" ? volumeUSDChange : 0,
                                    liquidityUSD: overviewData.totalLiquidityUSD,
                                    liquidityUSDChange: liquidityUSDChange,
                                    txCount: txCount,
                                    txCountChange: txCountChange
                                };
                                setFetchState({
                                    error: false,
                                    data: protocolData
                                });
                            }
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        var allBlocksAvailable = (block24 === null || block24 === void 0 ? void 0 : block24.number) && (block48 === null || block48 === void 0 ? void 0 : block48.number);
        if (allBlocksAvailable && !blockError && !fetchState.data) {
            fetch();
        }
    }, [
        block24,
        block48,
        blockError,
        fetchState
    ]);
    return fetchState;
};
/* harmony default export */ var overview = (useFetchProtocolData);

// EXTERNAL MODULE: ./src/config/constants/info.ts
var info = __webpack_require__(4003);
// EXTERNAL MODULE: ./src/state/info/queries/helpers.ts
var helpers = __webpack_require__(74472);
;// CONCATENATED MODULE: ./src/state/info/queries/protocol/chart.ts
/* eslint-disable no-await-in-loop */ 


function chart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query overviewCharts($startTime: Int!, $skip: Int!) {\n    pancakeDayDatas(first: 1000, skip: $skip, where: { date_gt: $startTime }, orderBy: date, orderDirection: asc) {\n      date\n      dailyVolumeUSD\n      totalLiquidityUSD\n    }\n  }\n"
    ]);
    chart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Data for displaying Liquidity and Volume charts on Overview page
 */ var PANCAKE_DAY_DATAS = (0,dist.gql)(chart_templateObject());
var getOverviewChartData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(skip) {
        var pancakeDayDatas, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return graphql/* infoClient.request */.dQ.request(PANCAKE_DAY_DATAS, {
                        startTime: info/* PCS_V2_START */.Rr,
                        skip: skip
                    });
                case 3:
                    pancakeDayDatas = _ctx.sent.pancakeDayDatas;
                    data = pancakeDayDatas.map(helpers/* mapDayData */.v5);
                    return _ctx.abrupt("return", {
                        data: data,
                        error: false
                    });
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Failed to fetch overview chart data", _ctx.t0);
                    return _ctx.abrupt("return", {
                        error: true
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function getOverviewChartData(skip) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch historic chart data
 */ var useFetchGlobalChartData = function() {
    var ref = (0,react.useState)(), overviewChartData = ref[0], setOverviewChartData = ref[1];
    var ref1 = (0,react.useState)(false), error = ref1[0], setError = ref1[1];
    (0,react.useEffect)(function() {
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,helpers/* fetchChartData */.Hr)(getOverviewChartData);
                        case 2:
                            data = _ctx.sent.data;
                            if (data) {
                                setOverviewChartData(data);
                            } else {
                                setError(true);
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!overviewChartData && !error) {
            fetch();
        }
    }, [
        overviewChartData,
        error
    ]);
    return {
        error: error,
        data: overviewChartData
    };
};
/* harmony default export */ var chart = (useFetchGlobalChartData);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/state/info/queries/protocol/transactions.ts




function transactions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query overviewTransactions {\n    mints: mints(first: 33, orderBy: timestamp, orderDirection: desc) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      to\n      amount0\n      amount1\n      amountUSD\n    }\n    swaps: swaps(first: 33, orderBy: timestamp, orderDirection: desc) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      from\n      amount0In\n      amount1In\n      amount0Out\n      amount1Out\n      amountUSD\n    }\n    burns: burns(first: 33, orderBy: timestamp, orderDirection: desc) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      sender\n      amount0\n      amount1\n      amountUSD\n    }\n  }\n"
    ]);
    transactions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Transactions for Transaction table on the Home page
 */ var GLOBAL_TRANSACTIONS = (0,dist.gql)(transactions_templateObject());
var fetchTopTransactions = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var data, mints, burns, swaps;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return graphql/* infoClient.request */.dQ.request(GLOBAL_TRANSACTIONS);
                case 3:
                    data = _ctx.sent;
                    if (data) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", undefined);
                case 6:
                    mints = data.mints.map(helpers/* mapMints */.k9);
                    burns = data.burns.map(helpers/* mapBurns */._h);
                    swaps = data.swaps.map(helpers/* mapSwaps */.H_);
                    return _ctx.abrupt("return", (0,_to_consumable_array/* default */.Z)(mints).concat((0,_to_consumable_array/* default */.Z)(burns), (0,_to_consumable_array/* default */.Z)(swaps)).sort(function(a, b) {
                        return parseInt(b.timestamp, 10) - parseInt(a.timestamp, 10);
                    }));
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", undefined);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function fetchTopTransactions() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var protocol_transactions = (fetchTopTransactions);

;// CONCATENATED MODULE: ./src/state/info/queries/pools/topPools.ts




function topPools_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query topPools($blacklist: [String!], $timestamp24hAgo: Int) {\n        pairDayDatas(\n          first: 30\n          where: { dailyTxns_gt: 300, token0_not_in: $blacklist, token1_not_in: $blacklist, date_gt: $timestamp24hAgo }\n          orderBy: dailyVolumeUSD\n          orderDirection: desc\n        ) {\n          id\n        }\n      }\n    "
    ]);
    topPools_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Initial pools to display on the home page
 */ var fetchTopPools = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(timestamp24hAgo) {
        var query, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    query = (0,dist.gql)(topPools_templateObject());
                    _ctx.next = 4;
                    return graphql/* infoClient.request */.dQ.request(query, {
                        blacklist: info/* TOKEN_BLACKLIST */.tE,
                        timestamp24hAgo: timestamp24hAgo
                    });
                case 4:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data.pairDayDatas.map(function(p) {
                        return p.id.split("-")[0];
                    }));
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Failed to fetch top pools", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchTopPools(timestamp24hAgo) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch top addresses by volume
 */ var useTopPoolAddresses = function() {
    var ref = (0,react.useState)([]), topPoolAddresses = ref[0], setTopPoolAddresses = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,getDeltaTimestamps/* getDeltaTimestamps */.z)(), 1), timestamp24hAgo = ref1[0];
    (0,react.useEffect)(function() {
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var addresses;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fetchTopPools(timestamp24hAgo);
                        case 2:
                            addresses = _ctx.sent;
                            setTopPoolAddresses(addresses);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (topPoolAddresses.length === 0) {
            fetch();
        }
    }, [
        topPoolAddresses,
        timestamp24hAgo
    ]);
    return topPoolAddresses;
};
/* harmony default export */ var topPools = (useTopPoolAddresses);

// EXTERNAL MODULE: ./src/state/info/queries/pools/poolData.ts
var poolData = __webpack_require__(71021);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/state/info/queries/tokens/tokenData.ts
/* eslint-disable no-param-reassign */ 





function tokenData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query tokens {\n        now: ",
        "\n        oneDayAgo: ",
        "\n        twoDaysAgo: ",
        "\n        oneWeekAgo: ",
        "\n        twoWeeksAgo: ",
        "\n      }\n    "
    ]);
    tokenData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







/**
 * Main token data to display on Token page
 */ var TOKEN_AT_BLOCK = function(block, tokens) {
    var addressesString = '["'.concat(tokens.join('","'), '"]');
    var blockString = block ? "block: {number: ".concat(block, "}") : "";
    return "tokens(\n      where: {id_in: ".concat(addressesString, "}\n      ").concat(blockString, "\n      orderBy: tradeVolumeUSD\n      orderDirection: desc\n    ) {\n      id\n      symbol\n      name\n      derivedBNB\n      derivedUSD\n      tradeVolumeUSD\n      totalTransactions\n      totalLiquidity\n    }\n  ");
};
var fetchTokenData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(block24h, block48h, block7d, block14d, tokenAddresses) {
        var query, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    query = (0,dist.gql)(tokenData_templateObject(), TOKEN_AT_BLOCK(null, tokenAddresses), TOKEN_AT_BLOCK(block24h, tokenAddresses), TOKEN_AT_BLOCK(block48h, tokenAddresses), TOKEN_AT_BLOCK(block7d, tokenAddresses), TOKEN_AT_BLOCK(block14d, tokenAddresses));
                    _ctx.next = 4;
                    return graphql/* infoClient.request */.dQ.request(query);
                case 4:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", {
                        data: data,
                        error: false
                    });
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Failed to fetch token data", _ctx.t0);
                    return _ctx.abrupt("return", {
                        error: true
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchTokenData(block24h, block48h, block7d, block14d, tokenAddresses) {
        return _ref.apply(this, arguments);
    };
}();
// Transforms tokens into "0xADDRESS: { ...TokenFields }" format and cast strings to numbers
var parseTokenData = function(tokens) {
    if (!tokens) {
        return {};
    }
    return tokens.reduce(function(accum, tokenData) {
        var derivedBNB = tokenData.derivedBNB, derivedUSD = tokenData.derivedUSD, tradeVolumeUSD = tokenData.tradeVolumeUSD, totalTransactions = tokenData.totalTransactions, totalLiquidity = tokenData.totalLiquidity;
        accum[tokenData.id] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tokenData), {
            derivedBNB: parseFloat(derivedBNB),
            derivedUSD: parseFloat(derivedUSD),
            tradeVolumeUSD: parseFloat(tradeVolumeUSD),
            totalTransactions: parseFloat(totalTransactions),
            totalLiquidity: parseFloat(totalLiquidity)
        });
        return accum;
    }, {});
};
/**
 * Fetch top addresses by volume
 */ var useFetchedTokenDatas = function(tokenAddresses) {
    var ref = (0,react.useState)({
        error: false
    }), fetchState = ref[0], setFetchState = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,getDeltaTimestamps/* getDeltaTimestamps */.z)(), 4), t24h = ref1[0], t48h = ref1[1], t7d = ref1[2], t14d = ref1[3];
    var ref2 = (0,useBlocksFromTimestamps/* useBlocksFromTimestamps */.Z)([
        t24h,
        t48h,
        t7d,
        t14d
    ]), blocks = ref2.blocks, blockError = ref2.error;
    var ref3 = (0,_sliced_to_array/* default */.Z)(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = ref3[0], block48h = ref3[1], block7d = ref3[2], block14d = ref3[3];
    (0,react.useEffect)(function() {
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, error, data, parsed, parsed24, parsed48, parsed7d, parsed14d, formatted;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fetchTokenData(block24h.number, block48h.number, block7d.number, block14d.number, tokenAddresses);
                        case 2:
                            ref = _ctx.sent;
                            error = ref.error;
                            data = ref.data;
                            if (error) {
                                setFetchState({
                                    error: true
                                });
                            } else {
                                parsed = parseTokenData(data === null || data === void 0 ? void 0 : data.now);
                                parsed24 = parseTokenData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                                parsed48 = parseTokenData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                                parsed7d = parseTokenData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                                parsed14d = parseTokenData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                                formatted = tokenAddresses.reduce(function(accum, address) {
                                    var current = parsed[address];
                                    var oneDay = parsed24[address];
                                    var twoDays = parsed48[address];
                                    var week = parsed7d[address];
                                    var twoWeeks = parsed14d[address];
                                    var ref = (0,_sliced_to_array/* default */.Z)((0,getChangeForPeriod/* getChangeForPeriod */.T)(current === null || current === void 0 ? void 0 : current.tradeVolumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.tradeVolumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.tradeVolumeUSD), 2), volumeUSD = ref[0], volumeUSDChange = ref[1];
                                    var ref1 = (0,_sliced_to_array/* default */.Z)((0,getChangeForPeriod/* getChangeForPeriod */.T)(current === null || current === void 0 ? void 0 : current.tradeVolumeUSD, week === null || week === void 0 ? void 0 : week.tradeVolumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.tradeVolumeUSD), 1), volumeUSDWeek = ref1[0];
                                    var liquidityUSD = current ? current.totalLiquidity * current.derivedUSD : 0;
                                    var liquidityUSDOneDayAgo = oneDay ? oneDay.totalLiquidity * oneDay.derivedUSD : 0;
                                    var liquidityUSDChange = (0,infoDataHelpers/* getPercentChange */.Y)(liquidityUSD, liquidityUSDOneDayAgo);
                                    var liquidityToken = current ? current.totalLiquidity : 0;
                                    // Prices of tokens for now, 24h ago and 7d ago
                                    var priceUSD = current ? current.derivedUSD : 0;
                                    var priceUSDOneDay = oneDay ? oneDay.derivedUSD : 0;
                                    var priceUSDWeek = week ? week.derivedUSD : 0;
                                    var priceUSDChange = (0,infoDataHelpers/* getPercentChange */.Y)(priceUSD, priceUSDOneDay);
                                    var priceUSDChangeWeek = (0,infoDataHelpers/* getPercentChange */.Y)(priceUSD, priceUSDWeek);
                                    var txCount = (0,infoDataHelpers/* getAmountChange */.D)(current === null || current === void 0 ? void 0 : current.totalTransactions, oneDay === null || oneDay === void 0 ? void 0 : oneDay.totalTransactions);
                                    var txCountAll = (0,infoDataHelpers/* getAmountChange */.D)(current === null || current === void 0 ? void 0 : current.totalTransactions, 0);
                                    accum[address] = {
                                        exists: !!current,
                                        address: address,
                                        name: current ? current.name : "",
                                        symbol: current ? current.symbol : "",
                                        volumeUSD: volumeUSD,
                                        volumeUSDChange: volumeUSDChange,
                                        volumeUSDWeek: volumeUSDWeek,
                                        txCount: txCount,
                                        txCountAll: txCountAll,
                                        liquidityUSD: liquidityUSD,
                                        liquidityUSDChange: liquidityUSDChange,
                                        liquidityToken: liquidityToken,
                                        priceUSD: priceUSD,
                                        priceUSDChange: priceUSDChange,
                                        priceUSDChangeWeek: priceUSDChangeWeek
                                    };
                                    return accum;
                                }, {});
                                setFetchState({
                                    data: formatted,
                                    error: false
                                });
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        var allBlocksAvailable = (block24h === null || block24h === void 0 ? void 0 : block24h.number) && (block48h === null || block48h === void 0 ? void 0 : block48h.number) && (block7d === null || block7d === void 0 ? void 0 : block7d.number) && (block14d === null || block14d === void 0 ? void 0 : block14d.number);
        if (tokenAddresses.length > 0 && allBlocksAvailable && !blockError) {
            fetch();
        }
    }, [
        tokenAddresses,
        block24h,
        block48h,
        block7d,
        block14d,
        blockError
    ]);
    return fetchState;
};
/* harmony default export */ var tokenData = (useFetchedTokenDatas);

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/topTokens.ts




function topTokens_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query topTokens($blacklist: [String!], $timestamp24hAgo: Int) {\n        tokenDayDatas(\n          first: 30\n          where: { dailyTxns_gt: 300, id_not_in: $blacklist, date_gt: $timestamp24hAgo }\n          orderBy: dailyVolumeUSD\n          orderDirection: desc\n        ) {\n          id\n        }\n      }\n    "
    ]);
    topTokens_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Tokens to display on Home page
 * The actual data is later requested in tokenData.ts
 * Note: dailyTxns_gt: 300 is there to prevent fetching incorrectly priced tokens with high dailyVolumeUSD
 */ var fetchTopTokens = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(timestamp24hAgo) {
        var query, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    query = (0,dist.gql)(topTokens_templateObject());
                    _ctx.next = 4;
                    return graphql/* infoClient.request */.dQ.request(query, {
                        blacklist: info/* TOKEN_BLACKLIST */.tE,
                        timestamp24hAgo: timestamp24hAgo
                    });
                case 4:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data.tokenDayDatas.map(function(t) {
                        return t.id.split("-")[0];
                    }));
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Failed to fetch top tokens", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchTopTokens(timestamp24hAgo) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch top addresses by volume
 */ var useTopTokenAddresses = function() {
    var ref = (0,react.useState)([]), topTokenAddresses = ref[0], setTopTokenAddresses = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,getDeltaTimestamps/* getDeltaTimestamps */.z)(), 1), timestamp24hAgo = ref1[0];
    (0,react.useEffect)(function() {
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var addresses;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fetchTopTokens(timestamp24hAgo);
                        case 2:
                            addresses = _ctx.sent;
                            setTopTokenAddresses(addresses);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (topTokenAddresses.length === 0) {
            fetch();
        }
    }, [
        topTokenAddresses,
        timestamp24hAgo
    ]);
    return topTokenAddresses;
};
/* harmony default export */ var topTokens = (useTopTokenAddresses);

// EXTERNAL MODULE: ./src/state/info/hooks.ts + 6 modules
var hooks = __webpack_require__(53985);
;// CONCATENATED MODULE: ./src/state/info/updaters.ts












var ProtocolUpdater = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useProtocolData */.rf)(), 2), protocolData = ref[0], setProtocolData = ref[1];
    var ref1 = overview(), fetchedProtocolData = ref1.data, error = ref1.error;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useProtocolChartData */.B5)(), 2), chartData = ref2[0], updateChartData = ref2[1];
    var ref3 = chart(), fetchedChartData = ref3.data, chartError = ref3.error;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useProtocolTransactions */.Wz)(), 2), transactions = ref4[0], updateTransactions = ref4[1];
    // update overview data if available and not set
    (0,react.useEffect)(function() {
        if (protocolData === undefined && fetchedProtocolData && !error) {
            setProtocolData(fetchedProtocolData);
        }
    }, [
        error,
        fetchedProtocolData,
        protocolData,
        setProtocolData
    ]);
    // update global chart data if available and not set
    (0,react.useEffect)(function() {
        if (chartData === undefined && fetchedChartData && !chartError) {
            updateChartData(fetchedChartData);
        }
    }, [
        chartData,
        chartError,
        fetchedChartData,
        updateChartData
    ]);
    (0,react.useEffect)(function() {
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return protocol_transactions();
                        case 2:
                            data = _ctx.sent;
                            if (data) {
                                updateTransactions(data);
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!transactions) {
            fetch();
        }
    }, [
        transactions,
        updateTransactions
    ]);
    return null;
};
var PoolUpdater = function() {
    var updatePoolData = (0,hooks/* useUpdatePoolData */.b0)();
    var addPoolKeys = (0,hooks/* useAddPoolKeys */.KX)();
    var allPoolData = (0,hooks/* useAllPoolData */.JX)();
    var addresses = topPools();
    // add top pools on first load
    (0,react.useEffect)(function() {
        if (addresses.length > 0) {
            addPoolKeys(addresses);
        }
    }, [
        addPoolKeys,
        addresses
    ]);
    // detect for which addresses we havent loaded pool data yet
    var unfetchedPoolAddresses = (0,react.useMemo)(function() {
        return Object.keys(allPoolData).reduce(function(accum, address) {
            var poolData = allPoolData[address];
            if (!poolData.data) {
                accum.push(address);
            }
            return accum;
        }, []);
    }, [
        allPoolData
    ]);
    // fetch data for unfetched pools and update them
    var ref = (0,poolData/* default */.ZP)(unfetchedPoolAddresses), poolDataError = ref.error, poolDatas = ref.data;
    (0,react.useEffect)(function() {
        if (poolDatas && !poolDataError) {
            updatePoolData(Object.values(poolDatas));
        }
    }, [
        poolDataError,
        poolDatas,
        updatePoolData
    ]);
    return null;
};
var TokenUpdater = function() {
    var updateTokenDatas = (0,hooks/* useUpdateTokenData */.pV)();
    var addTokenKeys = (0,hooks/* useAddTokenKeys */.Mn)();
    var allTokenData = (0,hooks/* useAllTokenData */.jv)();
    var addresses = topTokens();
    // add top tokens on first load
    (0,react.useEffect)(function() {
        if (addresses.length > 0) {
            addTokenKeys(addresses);
        }
    }, [
        addTokenKeys,
        addresses
    ]);
    // detect for which addresses we havent loaded token data yet
    var unfetchedTokenAddresses = (0,react.useMemo)(function() {
        return Object.keys(allTokenData).reduce(function(accum, key) {
            var tokenData = allTokenData[key];
            if (!tokenData.data) {
                accum.push(key);
            }
            return accum;
        }, []);
    }, [
        allTokenData
    ]);
    // fetch data for unfetched tokens and update them
    var ref = tokenData(unfetchedTokenAddresses), tokenDataError = ref.error, tokenDatas = ref.data;
    (0,react.useEffect)(function() {
        if (tokenDatas && !tokenDataError) {
            updateTokenDatas(Object.values(tokenDatas));
        }
    }, [
        tokenDataError,
        tokenDatas,
        updateTokenDatas
    ]);
    return null;
};

;// CONCATENATED MODULE: ./src/views/Info/index.tsx


var InfoPageLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolUpdater, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolUpdater, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenUpdater, {}),
            children
        ]
    });
};


/***/ })

}]);